<template>
	<div class="page-main">
		<div class="main-head">
			<div class="breakcrumbs">课程中心  >  详情</div>
			<!-- <div class="back-btn">返回</div> -->
		</div>
		
		<div class="course-page">
			
			<!-- 课程信息 -->
			<div class="course-info" v-if="detail">
				<div class="video-box">
					<div class="text" v-if="detail.imgType==1" :style="`background-color:${detail.courseColour};`">{{detail.courseName}}</div>
					<video v-if="detail.imgType==3" class="video" :src="detail.courseImg" controls=""></video>
					<img v-if="detail.imgType==2" class="video" :src="detail.courseImg" alt="">
				</div>
				<div class="info">
					<h4 class="title">{{detail.courseName}}
						<span class="status" :class="detail.offerCoursesClass">{{detail.offerCoursesName}}</span>
					</h4>
					<!-- <div class="des"></div> -->
					<div class="box">
						<div class="labels">
							<span class="act" v-if="detail.courseLevelName">{{detail.courseLevelName}}</span>
							<span v-if="detail.courseMajorLevelName">{{detail.courseMajorLevelName}}</span>
							<span v-if="detail.courseSubject">{{detail.courseSubject}}</span>
						</div>
					</div>
					
					<div class="more-info">
						<p class="ico1">主讲教师：{{detail.teacherName}} {{detail.teaTitle}} / {{detail.schoolSystem}}</p>
						<p class="ico2">开课学期：{{routeData.termName}}</p>
						<p class="ico3">开课时间：{{detail.courseStu.startTime}}至{{detail.courseStu.startTime}}</p>
						<p class="ico4">开课状态：{{detail.offerCoursesName}}</p>
						<p class="ico5">课程学时：{{detail.studyTime || 0}}学时</p>
						<!-- <p>选课人次：97人次</p> -->
					</div>
					<!-- <a href="javascript:;" class="join-btn">加入课程</a> -->
				</div>
			</div>
			
			<!-- 课程数据 -->
			<div class="course-datas" v-if="detail">
				<div class="item first">
					<div class="value">
						<span>
							<select class="select" name="" id="" @change="changeTerm($event.target.value)">
								<option :value ="item.id" v-for="(item,index) in detail.courseIssue" :key="item.id">{{item.qs}}</option>
							</select>
						</span>
					</div>
					<p>运行期次</p>
				</div>
				<div class="item">
					<div class="value"><span>{{recordData.allChooseCount || 0}}</span>人次</div>
					<p>累计选课</p>
				</div>
				<div class="item">
					<div class="value"><span>{{recordData.chooseCount || 0}}</span>人次</div>
					<p>本次选课</p>
				</div>
				<!-- <div class="item">
					<div class="value"><span>2684</span>万次</div>
					<p>累计互动</p>
				</div>
				<div class="item">
					<div class="value"><span>2684</span>次</div>
					<p>本次互动</p>
				</div> -->
				<div class="item">
					<div class="value"><span>{{recordData.allVisitCount || 0}}</span>次</div>
					<p>累计访问</p>
				</div>
				<div class="item">
					<div class="value"><span>{{recordData.visitCount || 0}}</span>次</div>
					<p>本次访问</p>
				</div>
			</div>
			
			<div class="course-detail" v-if="detail">
				<!-- 左侧 -->
				<div class="d-left">
					<div class="tag-box">
						<span :class="{act:index==courseTagIndex}" v-for="(item,index) in courseTag" :key="index"
							@click="changeCourseTag(index)">{{item}}</span>
					</div>
					
					<!-- 课程介绍 -->
					<div class="course-intro" v-if="courseTagIndex==0">
						<div class="intro" v-html="detail.introduction"></div>
						<div class="intro-head">
							<img src="../../static/img/course/intor-tit.png" alt="">课程概述
						</div>
						<div class="course-html" v-html="detail.courseOverview"></div>
					</div>
					
					<!-- 章节 -->
					<div class="chapter-box" v-if="courseTagIndex==1">
						<div class="chapter-item" v-for="(item,index) in chapterList" :key="index">
							<div class="head" :class="{show:item.show}" @click="openChapter(index)">{{item.chapterName}}</div>
							<ul class="list" v-show="item.show">
								<li :class="item2.actTypeClass" v-for="(item2,index2) in item.actList" :key="index2">
									<p>{{item2.actName}}</p>
									<!-- <div class="status" :class="'ico-status'+item2.status">{{item2.statusName}}</div> -->
								</li>
							</ul>
						</div>
					</div>
					
					<!-- 课程评价 -->
					<div class="comment" v-if="courseTagIndex==2 && false">
						<div class="comment-head">
							<div class="total">
								<div class="score"><span>5.0</span>分</div>
								<div class="des">
									<van-rate v-model="commentScroe" :size="22" readonly  color="#2E75EB" void-icon="star" void-color="#eee" />
									<span class="text">共 0 条评价</span>
								</div>
							</div>
							<div class="btns">
								<span>全部</span>
								<span  class="act">本期开课</span>
							</div>
						</div>
						<van-empty  description="暂无评价" />
						<ul class="comment-list">
							<li v-for="(item,index) in [1,2,3,4,5]">
								<img class="pic" src="../../static/img/temp/1.png" alt="">
								<div class="info">
									<div class="top">
										<span class="name">王琑儿</span>
										<span class="label">我</span>
										<div class="star-box">
											<van-rate v-model="commentScroe" :size="18" readonly  color="#2E75EB" void-icon="star" void-color="#eee" />
										</div>
									</div>
									<div class="date-time">2022-10-09 08:00:00</div>
									<div class="comment-content">
										品牌也远不是强调名称，标志，符号或者商标。它融合了一系列定义其形象的独特价值，并作为一份不成文的合同，通过在消费者每一次购买，使用，体验是提供始终如一的产品和服务。同时还在寻求与消费者的情感联系，确保终身关系
									</div>
								</div>
							</li>
						</ul>
					</div>
					
				</div>
				
				<!-- 右侧 -->
				<div class="d-right">
					<div class="logo">
						<img :src="detail.orgLogo" alt="">
					</div>
					<ul class="teacher-list">
						<li v-for="(item,index) in detail.teacherInfoVos" :key="item.teacherId">
							<div class="top">
								<img class="pic" :style="!item.headImage?'width:96px; height:96px; margin-right:3px;':''" :src="item.headImage || dfHead" alt="">
								<div class="info":style="!item.headImage?'padding-top:16px;':''" >
									<div class="name">
										<h4>{{item.teacherName}}</h4>
										<span :class="item.teacherTypeClass">{{item.teacherTypeName}}</span>
									</div>
									<div class="des">{{item.schoolSystem}}   {{item.title?' | '+item.title:''}}</div>
								</div>
							</div>
							<div class="intro" v-if="item.introduction">{{item.introduction}}</div>
						</li>
					</ul>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
import { Rate } from 'vant';
export default {
	components:{
		vanRate:Rate
	},
	data () {
		return {
			courseId:'',	//课程id
			routeData:{},	//路由返回的信息(startTime, endTime, termName, termId, offerCourses)
			detail:null,	//详情
			
			courseTag:[
				'课程介绍','课程章节'
				// '课程介绍','课程章节','课程评价'
			],
			courseTagIndex:0,
			recordData:{},	//统计数据
			nowIndex:0,
			
			chapterList:[]	,//章节列表
			commentScroe:5
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.courseId =  this.$route.params.id
		this.routeData = this.$route.query
		this.getDetail()
		this.getRecordData()
		this.recordVisitData()
		this.getChapterList()
	},
  
	computed:{
		
	},
  
	methods:{
		//详情选项卡切换
		changeCourseTag(index){
			this.courseTagIndex = index
		},
		
		
		//根据课程ID查询详细数据
		getDetail(){
			const { courseId } = this
			const { termId } = this.routeData
			this.$axios({
				url:`/jxedu/api/site/findDetailById/${courseId}/${termId}`,
			}).then(res=>{
				let detail = res.data
				switch(detail.courseLevel){	//课程级别：0普通网课 1联盟精品课 2国家精品课 3省级精品课
					case 1: detail.courseLevelName = '省级精品'; detail.courseLevelClass = 'blue'; break;
					case 2: detail.courseLevelName = '国家精品'; detail.courseLevelClass = 'blue'; break;
					case 3: detail.courseLevelName = '省级线上一流'; detail.courseLevelClass = 'orange'; break;
					case 4: detail.courseLevelName = '国家线上一流'; detail.courseLevelClass = 'green'; break;
				}
				
				// switch(detail.schoolType){	//院校类型:1本科院校 2高职高专 3开发大学 4教育机构
				// 	case 1: detail.schoolTypeName = '本科院校'; break;
				// 	case 2: detail.schoolTypeName = '高职院校'; break;
				// 	case 3: detail.schoolTypeName = '开发大学'; break;
				// 	case 4: detail.schoolTypeName = '教育机构'; break;
				// }
				switch(detail.courseStu.offerCourses){	//开课状态：0:全部，1:即将开课,2:开课中,3:已结课,4:暂未开课
					case 1: detail.offerCoursesName = '即将开课'; detail.offerCoursesClass = 'orange'; break;
					case 2:detail.offerCoursesName = '开课中'; detail.offerCoursesClass = 'blue'; break;
					case 3:detail.offerCoursesName = '已结课'; detail.offerCoursesClass = 'gray'; break;
					case 4:detail.offerCoursesName = '暂未开课';detail.offerCoursesClass = 'gray'; break;
				}
				switch(detail.courseMajorLevel){	
					case 1: detail.courseMajorLevelName = '本科';  break;
					case 2:detail.courseMajorLevelName = '高职'; break;
				}
				
				detail.teacherInfoVos.forEach(item=>{
					switch(item.teacherType){	//老师分类：1责任老师 3主讲老师
						case 1: item.teacherTypeName = '责任老师'; item.teacherTypeClass='blue'; break;
						case 3: item.teacherTypeName = '主讲老师'; item.teacherTypeClass='orange'; break;
					}
				})
				// detail.courseIssueArr = detail.courseIssue.map((item,index)=>{
				// 	return {
				// 		title : `第${index+1}期`,
				// 		termId : item
				// 	}
				// })
				this.detail = detail
			})
		},
		
		//根据课程期数查询累计、访问数据
		getRecordData(){
			const { courseId } = this
			const { termId } = this.routeData
			this.$axios({
				url:`/jxedu/api/site/findByTermId/${courseId}/${termId}`,
			}).then(res=>{
				this.recordData = res.data
			})
		},
		
		//获取课程章节
		getChapterList(){
			const { courseId } = this
			const { termId } = this.routeData
			this.$axios({
				url:`/jxedu/api/site/findChapterById/${courseId}`,
			}).then(res=>{
				let list = res.data
				list.forEach(item=>{
					item.show = true
					item.actList.forEach(item2=>{	//活动类型 1视频 2文本 3测验 4讨论
						switch(item2.actType){
							case 1: 
								item2.actTypeName = '【视频学习】';
								item2.actTypeClass = 'ico-video';
								break;
							case 2:
								item2.actTypeName = '【文本学习】';
								item2.actTypeClass = '';
								break;
							case 3:
								item2.actTypeName = '【测验学习】';
								item2.actTypeClass = 'ico-homeword';
								break;
							case 4:
								item2.actTypeName = '【讨论学习】';
								item2.actTypeClass = 'ico-comment';
								break;
						}
					})
				})
				this.chapterList = list
			})
		},
		
		//展开关闭章节
		openChapter(index){
			const { show } = this.chapterList[index]
			this.chapterList[index].show = !show
		},
		
		//记录站点访问数据
		recordVisitData(){
			const { courseId } = this
			const { termId } = this.routeData
			let ytSiteVisitInfo = {
				objectId:courseId,
				termId:termId,
				visitType:1,
			}
			this.$axios({
				url:`/jxedu/site/visit/recordVisitData`,
				method:'POST',
				data:ytSiteVisitInfo,
			})
		},
		
		//切换运行期次
		changeTerm(termId){
			this.routeData.termId = termId
			this.getDetail()
		}
	}
}
</script>

<style lang="less" scoped>
.page-mdl{ background:#F7F8FA; padding:40px 0 60px;}
.course-page{
	background:#fff; padding:40px 30px; box-sizing: border-box;
	// 课程信息
	.course-info{
		display:flex;
		.video-box{
			width:600px; height:340px; background:#000; margin-right:30px;
			.video{ width:100%; height:100%; }
			.text{ 
				width:100%; height:100%; display:flex; justify-content: center; align-items: center; 
				font-size:48px; color:#fff; line-height:68px; font-weight: bold; letter-spacing: 10px;
				padding:0 50px; text-align: center; box-sizing: border-box;
			}
		}
		.info{
			flex:1; padding-top:4px; position:relative;
			.title{ 
				font-size:24px;color:#333333; line-height:28px; font-weight: bold; 
				.status{
					display: inline-block; width:72px; height:28px; line-height:28px; text-align: center;font-size:14px; color:#fff;
					background:url('../../static/img/course/bg-kkz.png'); background-size:72px 28px; margin-left:10px; vertical-align: top;
					&.orange{ background-image:url('../../static/img/course/bg-jjkk.png');  }
					&.gray{background-image:url('../../static/img/course/bg-yjs.png'); }
				}
			}
			.des{ font-size:14px; color:#333333; line-height:24px; margin-top:6px; }
			.box{
				display:flex; margin-top:16px;
				.labels{
					flex:1; display:flex; flex-wrap:wrap;
					span{ 
						display:inline-block; height:22px; line-height:22px; padding:0 20px; border-radius: 11px; box-sizing: border-box;
						background:#fff; font-size:14px; color:#343E4F; border:1px solid #EBECEE; margin-right:10px;
						&.act{ background-image:url('../../static/img/course/label-bg1.png'); color:#fff; }
					}
				}
				
			}
			.more-info{
				margin-top:32px;
				p{ 
					font-size:14px; color:#666666; line-height:30px; position:relative; padding-left:28px;
					&::before{ 
						content:''; display:inline-block; width:18px; height:18px; position:absolute; left:0; top:6px;
						background:url(../../static/img/course/ico1.png) no-repeat; background-size:18px 18px;
					}
					&.ico1::before{ background-image:url(../../static/img/course/ico1.png); }
					&.ico2::before{ background-image:url(../../static/img/course/ico2.png); }
					&.ico3::before{ background-image:url(../../static/img/course/ico3.png); }
					&.ico4::before{ background-image:url(../../static/img/course/ico4.png); }
					&.ico5::before{ background-image:url(../../static/img/course/ico5.png); }
				}
			}
			.join-btn{
				display:inline-flex; justify-content: center; align-items: center; height:42px; width:150px; text-align:center; background: #2E75EB; 
				position:absolute; bottom:5px; left:0; font-size:18px; color:#FFFFFF; border-radius: 21px;
				&:hover{ opacity: .9;}  
			}
		}
	}

	//课程数据
	.course-datas{
		display:flex; margin-top:40px; height: 145px; background: #FFFFFF; box-shadow: 0px 0px 18px 0px rgba(41,134,230,0.1500); border-radius: 15px;padding:29px 0 42px; box-sizing: border-box;
		.item{
			flex:1; display:flex; align-items: center; justify-content: center; flex-wrap:wrap;
			.value{
				font-size:14px; color:#2E75EB; line-height:22px; 
				span{ display:inline-block; font-size:28px;  font-weight: bold; line-height:28px; margin-right:4px; vertical-align: bottom;}
				
			}
			p{ font-size:14px; color:#AEB2B9; line-height:14px; width:100%; text-align: center; margin-top:14px;}
			&.first{
				position:relative;
				// &::after{ 
				// 	content:''; display:inline-block; width:2px; height:60px; background:#D8D8D8;
				// 	position:absolute; right:0; top:50%; margin-top:-30px;
				// }
				// .value .select{
				// 	display:inline-block;  color:#1677FF; font-weight: bold; line-height:28px; vertical-align: bottom; 
				// 	font-size:20px; position:relative; margin-right:0; cursor:pointer;
				// 	&::after{
				// 		content:''; width:0px; height:0px; overflow:hidden; font-size:0px; display:inline-block; border-style:solid;
				// 		 border-width:6px 5px 0px 5px; border-color:#1677FF transparent transparent transparent; 
				// 		 position:absolute; top:13px; right:-14px;
				// 	}
				// }
				.value span{ 
					font-size:20px; position:relative; margin-right:0; cursor:pointer; border:1px solid #DFE3ED; border-radius: 4px;
					width:120px; height:48px; display:inline-flex; align-items: center; padding-left:14px;
					.select{	
						display:inline-block;  color:#1677FF; font-weight: bold; line-height:28px; vertical-align: bottom; 
						font-size:20px; position:relative; margin-right:0; cursor:pointer; width:100%;
					}
					&::after{
						content:''; width:0px; height:0px; overflow:hidden; font-size:0px; display:inline-block; border-style:solid;
						 border-width:6px 5px 0px 5px; border-color:#1677FF transparent transparent transparent; 
						 position:absolute; top:50%; right:14px; margin-top:-3px;
					}
				}
			}
		}
	}
	
	// 课程详情
	.course-detail{
		margin-top:40px; display:flex; 
		.d-left{
			flex:1; 
			.course-intro{
				padding:0 20px 20px;
				.intro{
					background:#EDF0F7; border: 1px solid #F7F8FA; padding:30px 46px 25px 70px;
					font-size:16px; color:#131F33; line-height:34px; border-radius: 15px; position:relative;
					&::before{ 
						content:''; width:34px; height:29px; position:absolute; left:22px; top:16px; 
						background:url('../../static/img/course/ico-yh.png') no-repeat; background-size:34px 29px;
					}
				}
				.intro-head{
					display:flex; align-items: center; margin-top:22px; font-size:18px; color:#2E75EB; font-weight: bold;
					img{ width:64px; height:64px; margin-right:8px;}
				}
				.course-html{
					 font-size:14px; color:#666; line-height:30px; padding:0 74px;
				}
			}
			
			// 章节
			.chapter-box{
				.chapter-item{
					border-bottom:1px solid #EEEEEE;
					.head{
						height:48px; display: flex; align-items: center; padding-left:20px; position:relative;
						font-size:16px; color:#131F33; font-weight: bold; cursor: default; background:#F7FAFF; 
						border-top:1px solid #E2ECFF; border-bottom:1px solid #E2ECFF;
						&::before{
							content:''; display:inline-block; width: 7px; height: 40px; background: #C8D2E4; border-radius:0 7px 7px 0;
							position:absolute; left:0; top:50%; margin-top:-20px;
						}
						&.show::before{ background: #2E75EB; }
					}
					.list{
						li{
							height:52px; display:flex; justify-content: space-between; border-bottom:1px dashed #EEEEEE;
							align-items: center; padding:0 20px 0 48px; cursor: text;
							background:url('../../static/img/course/c-ico04.png') #fff no-repeat 20px center; background-size:20px 20px;
							&:last-child{ border-bottom:none;}
							&.ico-comment{ background-image:url('../../static/img/course/c-ico03.png'); }
							&.ico-video{ background-image:url('../../static/img/course/c-ico01.png'); }
							&.ico-homeword{ background-image:url('../../static/img/course/c-ico02.png'); }
							p{ font-size:16px; color:#333333; }
							.status{ 
								font-size:14px; color:#999; padding-left:30px; height:20px; line-height:20px; 
								background:url('../../static/img/course/ico-status1.png') #fff no-repeat 0px center; 
								background-size:20px 20px; width:70px;
								&.ico-status2{  background-image:url('../../static/img/course/ico-status2.png'); }
								&.ico-status3{  background-image:url('../../static/img/course/ico-status3.png'); color:#47AB17;}
							}
							// &:hover{
							// 	box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.09); 
							// 	p{ color:#1677FF; }
							// }
						}
					}
				}
			}
		
			// 评论
			.comment{
				 
				.star-box{
					display:inline-flex;
					span{ 
						display:inline-block; width:16px; height:16px; background:url('../../static/img/course/star.gif') no-repeat 0 0; margin-right:2px;
						&.act{ background-position:0 -32px; }
					}
				}
				.comment-head{
					display:flex; justify-content: space-between; align-items: center; padding:17px 24px; height: 84px; box-sizing: border-box;
					background: #F7FAFF; border: 1px solid #E2ECFF;
					.total{
						display:flex; align-items: center;
						.score{ 
							font-size:16px; color:#2E75EB; margin-bottom:8px; margin-right:28px;
							span{ font-size:48px; margin-right:2px;  font-weight: bold; }
						}
						.des{
							
							.text{display:block; font-size: 14px; color:#AEB2B9; line-height:20px; margin-top:4px; }
						}
					}
					.btns{
						display: flex;
						span{ 
							display:inline-flex; align-items: center; justify-content: center; height:34px; border:1px solid #E2ECFF; 
							width:74px; text-align: center;  color:#485161; font-size:14px; cursor: pointer;
							&:first-child{  border-radius:4px 0 0 4px; position:relative; }
							&:last-child{  left:-1px; border-radius:0 4px 4px 0; }
							&.act{ border-color:#2E75EB; background:#2E75EB; color:#fff; z-index:9; }
						}
					}
				}
				.comment-list{
					
					li{
						display:flex;  padding:20px 0;
						img{ width:72px; height:72px; border-radius:100%; margin-right:20px; }
						.info{
							flex:1;
							.top{
								display:flex; align-items: center;
								.name{ font-size:16px; line-height:24px; color:#131F33; font-weight: bold; }
								.label{ 
									display:inline-block; background:#EBF3FF;height:14px; font-size:12px; line-height:14px; color:#3386F1; 
									margin-left:8px; padding:0 4px; border-radius: 3px; margin-right:10px;
								}
							}
							.date-time{ font-size:12px; color:#AEB2B9; line-height:12px; margin-top:4px;}
							.comment-content{
								font-size:14px; color:#131F33; line-height:24px; margin-top:20px; background: #EDF1F7;
								border-radius:0 10px 10px 10px; padding:20px 24px; position:relative;
								&::after{
									content:''; display:inline-block; width:0px; height:0px; overflow:hidden; font-size:0px; 
									display:inline-block; border-style:solid; border-width:12px 0px 0 12px; 
									border-color:transparent transparent transparent #EDF1F7; position:absolute; top:-12px; left:0;
								}
							}
						}
					}
				}
				.nothing{
					padding:100px 0; text-align:center; color:#999; font-size:24px;
				}
				
			}
		
		}
		.d-right{
			width:330px; margin-left:20px; background: #FFFFFF; border: 1px solid #EEEEEE; 
			.logo{
				padding:20px; border-bottom:1px solid #eee; display:flex; justify-content: center;
				img{ height:80px; }
			}
			.teacher-list{
				li{
					padding:20px;
					.top{
						display:flex;
						.pic{ width:60px; height:60px; border-radius:100%; margin-right:20px; }
						.info{
							padding-top:10px;
							.name{
								display:flex; 
								h4{ font-size:18px; color:#333333; line-height:18px; font-weight: bold; margin-right:15px;}
								span{ 
									display:inline-block; width:84px; height: 22px; line-height:22px;  text-align: center;
									background:url('../../static/img/course/type-blue.png') no-repeat; background-size:84px 22px; 
									color:#fff; font-size:14px;
									&.orange{ background:url('../../static/img/course/type-orange.png'); }
								}
							}
							.des{ font-size:12px; color:#666666; margin-top:12px; }
						}
					}
					.intro{
						font-size:12px; color:#666666; line-height:20px; margin-top:14px; text-indent: 2em;
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/course-detail/tpl-pc.vue